import { getMarketGoodsList } from '@/axios/market'

const marketGoodsList = {
  state: {
    marketGoodsList: {}
  },
  mutations: {
    SET_DETAIL (state, marketGoodsList) {
      state.marketGoodsList = marketGoodsList
    }
  },
  actions: {
    MARKGOODSLIST ({ commit }, params) {
      getMarketGoodsList(params).then(res => {
        this.state.marketGoodsList = res.data.data
      })
    }
  }
}

export default marketGoodsList



// WEBPACK FOOTER //
// ./src/store/modules/getMarketGoodsList.js